<template>
  <div class="instruction-wrapper">
    <div class="edit-btn-wrap flex">
      <span class="edit-teach-btn" @click="switchTeachEdit">{{
        initEditBtn
      }}</span>
      <span class="refresh-teach-btn" @click="getUserInstruction(3)"
        >刷新家训</span
      >
    </div>
    <div class="edit-teach-wrap">
      <el-form
        :model="editTeachForm"
        :rules="teachRules"
        ref="editTeachForm"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item prop="teacContent">
          <el-input
            type="textarea"
            class="teach-input-container"
            v-model="editTeachForm.teacContent"
            resize="none"
            maxlength="100"
            show-word-limit
            :autosize="{ minRows: 3 }"
            placeholder="输入家训"
          ></el-input>
        </el-form-item>
        <el-form-item v-show="editTeachOn">
          <div class="edit-bar">
            <el-button
              class="edit-form-btn"
              type="primary"
              @click="submitForm('editTeachForm')"
              >保存</el-button
            >
            <el-button class="edit-form-btn" @click="resetForm('editTeachForm')"
              >重置</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="teach-list-wrap">
      <div class="list-btn-bar flex">
        <span class="get-list-btn" @click="switchTeachList">修改记录</span>
        <p v-show="hasTeach.show">
          创建人：
          <span class="editor-name">{{ hasTeach.userName }}</span>
          <span>{{ hasTeach.addTime }}</span>
        </p>
      </div>
      <div v-show="teachListOn">
        <div class="no-list" v-if="teachList.length == 0">
          <p class="no-list-tip">{{ listStatusText }}</p>
        </div>
        <div class="teach-list-container" v-else>
          <div
            class="teach-list-item"
            v-for="(item, index) in teachList"
            :key="index"
          >
            <el-input
              type="textarea"
              class="teach-input-container"
              v-model="item.text"
              resize="none"
              :autosize="{ minRows: 1 }"
            ></el-input>
            <div class="teach-item-footer">
              <p>
                创建人：
                <span class="editor-name">{{ item.userInfo.realName }}</span>
                <span>{{ initAddTime(item.addTime) }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../../utils/apiMap";
import { getDate } from "../../utils/date";
export default {
  name: "edit-teach",
  data() {
    return {
      editTeachOn: false,
      teachListOn: false,
      editTeachForm: {
        teacContent: "",
      },
      teachRules: {
        teacContent: [
          { required: true, message: "请输入家训", trigger: "blur" },
        ],
      },
      teachList: [],
      listStatusText: "正在获取记录",
      hasTeach: {
        show: false,
        userName: "",
        addTime: 0,
      },
    };
  },
  computed: {
    initEditBtn() {
      return this.editTeachOn == false ? "编辑家训" : "取消编辑";
    },
  },
  mounted() {
    this.getUserInstruction(1);
  },
  methods: {
    switchTeachEdit() {
      if (this.editTeachOn == false) {
        this.editTeachOn = true;
      } else {
        this.editTeachOn = false;
      }
    },
    switchTeachList() {
      if (this.teachListOn == false) {
        this.teachListOn = true;
        this.getUserInstruction(2);
      } else {
        this.teachListOn = false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addTeach(this.$refs[formName].model.teacContent);
        } else {
          return false;
        }
      });
    },
    addTeach(content) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (!loginUser) {
        console.log("未查询到登录用户！");
        return;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["addIntro"]["method"],
          url: apiMap["addIntro"]["url"],
          data: `token=${loginUser.token}&text=${content}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.$message({
              message: "操作成功！",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.switchTeachEdit();
            _this.getUserInstruction(1);
          } else {
            _this.$message({
              message: "操作失败，稍后再试",
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error.message);
          if (error.message.includes("Network")) {
            window.location.reload();
          }
        });
    },
    initAddTime(timeStamp) {
      return getDate(new Date(timeStamp * 1000), ".");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getUserInstruction(scene) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (!loginUser) {
        console.log("未查询到登录用户！");
        return;
      }
      if (scene == 3) {
        _this.$message({
          type: "success",
          message: "正在刷新……",
          duration: 1500,
          offset: 230,
        });
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["familyIntro"]["method"],
          url: apiMap["familyIntro"]["url"],
          params: {
            token: loginUser.token,
            count: scene,
            type: 1,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (scene == 1) {
              _this.editTeachForm.teacContent = response.data.result.data.text;
              _this.hasTeach.show = true;
              _this.hasTeach.userName =
                response.data.result.data.userInfo.realName;
              _this.hasTeach.addTime = _this.initAddTime(
                response.data.result.data.addTime
              );
            } else {
              _this.teachList = response.data.result.data;
            }
          } else {
            if (scene == 1 || scene == 3) {
              var tempTeach =
                "家训是子孙立身处世、持家治业的行动指南和约束，也是家庭文化氛围、团结向上的象征。一般由家族中德高望重的人设立，或集体议定。";
              _this.editTeachForm.teacContent = tempTeach;
            } else {
              _this.listStatusText = "暂无记录";
            }
          }
        })
        .catch(function(error) {
          console.log(error);
          console.log(error.message);
        });
    },
  },
};
</script>
<style scoped>
.instruction-wrapper {
  padding: 10px 15px;
  box-sizing: border-box;
}

.edit-btn-wrap {
  justify-content: space-between;
}

.edit-teach-btn {
  display: inline-block;
  height: 23px;
  line-height: 25px;
  padding-left: 30px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../../assets/icon/cl_new_article.png");
}

.refresh-teach-btn {
  display: none;
  cursor: pointer;
  color: #1a70db;
}

.instruction-wrapper:hover .refresh-teach-btn {
  display: inline-block;
}

.edit-teach-btn:hover {
  color: #1a70db;
}

.edit-teach-wrap {
  margin: 10px 0;
}

.teach-input-container {
  font-size: 16px;
}

.edit-form-btn {
  padding: 7px 10px;
}

.list-btn-bar {
  justify-content: space-between;
}

.get-list-btn {
  cursor: pointer;
  color: #1a70db;
}

.editor-name {
  margin: 0 10px 0 6px;
}

.teach-list-item {
  margin-top: 15px;
}

.teach-item-footer {
  display: flex;
  justify-content: flex-end;
  line-height: 30px;
}

.no-list-tip {
  padding: 5px 15px;
  text-align: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>
